import React from 'react';
import cn from 'classnames';

import css from 'styles/components/common/card.scss';

export const Card = props => {
  const { children, className, ...rest } = props;

  return (
    <article
      className={cn(css.card, className)}
      {...rest}>
      {children}
    </article>
  );
};

export default Card;

